import type {BigCalendarEvent, BigCalendarUser} from 'platform/big-calendar';

import {isNil} from 'ramda';

import {useGetCurrentUserInfoQuery} from '@dms/api/customer';
import {useListTestDriveV2Query} from '@dms/api/sales';

import {EMPTY_PLACEHOLDER, useRequiredParams} from 'shared/web';

import {transformTestDriveToCalendarEvent} from '../utils/transformTestDriveToCalendarEvent';

export function useBigCalendarControl() {
  const {id: vehicleId} = useRequiredParams();

  const {data: userData} = useGetCurrentUserInfoQuery();

  const {
    data: testDrives = [],
    isLoading,
    isError,
  } = useListTestDriveV2Query({
    vehicleId,
  });

  const calendarEvents: BigCalendarEvent[] = testDrives.map(transformTestDriveToCalendarEvent);

  const currentUser: BigCalendarUser | null = isNil(userData)
    ? null
    : {
        id: userData.id,
        email: userData.email,
        fullName:
          [userData.firstName, userData.lastName].filter(Boolean).join(' ') || EMPTY_PLACEHOLDER,
      };

  return {
    events: calendarEvents,
    isLoading,
    isError,
    currentUser,
  };
}
